import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: 'flex';
  flex-direction: 'row';
  align-items: 'center';
  direction: 'rtl';
`;

export const CarouselWrapper = styled.div<{ elHeight: number; }>`
  width: '100%';
  height: ${({ elHeight }) => elHeight}px;
  position: 'relative';
`;
